/**
 * 唯一ID
 * 说明：在无法拿到设备ID的场景下生成唯一ID，用于统计
 */

export default class COOKIEID {
  constructor() {
    this.id = COOKIEID.createCookieid()
  }
  static createCookieid() {
    // Loose interpretation of the specification DCE 1.1: Remote Procedure Call
    // since JavaScript doesn't allow access to internal systems, the last 48
    // bits
    // of the node section is made up using a series of random numbers (6 octets
    // long)
    const dg = new Date(1582, 10, 15, 0, 0, 0, 0)
    const dc = new Date()
    const t = dc.getTime() - dg.getTime()
    const tl = COOKIEID.getIntegerBits(t, 0, 31)
    const tm = COOKIEID.getIntegerBits(t, 32, 47)
    const thv = COOKIEID.getIntegerBits(t, 48, 59) + '1'
    const csar = COOKIEID.getIntegerBits(COOKIEID.rand(4095), 0, 7)
    const csl = COOKIEID.getIntegerBits(COOKIEID.rand(4095), 0, 7)

    // since detection of anything about the machine/browser is far to buggy,
    // include some more random numbers here
    // if NIC or an IP can be obtained reliably, that should be put in
    // here instead.
    const n = COOKIEID.getIntegerBits(COOKIEID.rand(8191), 0, 7) +
      COOKIEID.getIntegerBits(COOKIEID.rand(8191), 8, 15) +
      COOKIEID.getIntegerBits(COOKIEID.rand(8191), 0, 7) +
      COOKIEID.getIntegerBits(COOKIEID.rand(8191), 8, 15) +
      COOKIEID.getIntegerBits(COOKIEID.rand(8191), 0, 15) // this last number
    return tl + tm + thv + csar + csl + n
  }
  static getIntegerBits(val, start, end) {
    const base16 = COOKIEID.returnBase(val, 16)
    const quadArray = []
    let quadString = ''
    let i = 0
    for (i = 0; i < base16.length; i++) {
      quadArray.push(base16.substring(i, i + 1))
    }
    for (i = Math.floor(start / 4); i <= Math.floor(end / 4); i++) {
      if (!quadArray[i] || quadArray[i] === '') {
        quadString += '0'
      } else {
        quadString += quadArray[i]
      }
    }
    return quadString
  }
  static returnBase(number, base) {
    return (number).toString(base).toUpperCase()
  }
  static rand(max) {
    return Math.floor(Math.random() * (max + 1))
  }
  valueOf() {
    return this.id
  }
  toString() {
    return this.id
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/collect/src/lib/cookieid.js